import { DadosAnexoAdicionado } from "./types";
import { mapearAnexos } from "../../Compartilhado/utils";

export const mapearDadosAnexoAdicionado = (logs: any[]): DadosAnexoAdicionado | null => {
    const anexos = mapearAnexos(logs);
    
    if (anexos.length === 0) {
        return null;
    }

    return {
        anexos
    };
};

